import axios, { AxiosError, Method } from 'axios'
import { CustomErrorResponse } from '../types/axiosTypes'
import { combineUrl } from './utils'

const ownAnonymousAxios = axios.create()

export const anonymousRequest = async <TRequest, TResponse>(
	path: string[],
	method: Method = 'GET',
	body?: TRequest,
	queryParams?: Record<string, string | number>,
): Promise<TResponse> => {
	const upperCaseMethod = method.toUpperCase()
	const apiUrl = process.env.REACT_APP_BASE_URL || ''
	const defaultApiUrl = 'api/v1/master-agent'

	const requestUri = combineUrl(apiUrl, defaultApiUrl, ...path)
	// const requestUri = combineUrl(apiUrl, ...path)

	try {
		const response = await ownAnonymousAxios({
			method: upperCaseMethod,
			baseURL: requestUri,
			headers: {
				'Content-Type': 'application/json',
			},
			data: body,
			params: queryParams,
			responseType: 'json',
		})
		return response.data as TResponse
	} catch (error) {
		const e = error as AxiosError
		let customErrorResponse = JSON.parse(e.request.response) as CustomErrorResponse
		return Promise.reject(customErrorResponse)
	}
}
